// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"356":"6b48156c","853":"e148a06c","3930":"6b48156c"}[chunkId] + ".chunk.css";
};